import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ModuleDetailPageRoutingModule } from "./module-detail-routing.module";
import { ModuleDetailPage } from "./module-detail.page";
import { PopoverModule } from "src/app/components/popover/popover.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ModuleDetailPageRoutingModule, PopoverModule, TranslateModule],
  declarations: [ModuleDetailPage],
})
export class ModuleDetailPageModule {}
